import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAiQuestionGroupData, getAiSubTitleData, getAiTitleData, getAllQuestions, getUpdateQuestionsData, getaAiChatTitleDetails } from "../../features/aiControl/aiControlSlice";
import Btn from "../../components/shared/button/Btn";
import { showModal } from "../../features/modal/modalSlice";
import { MdOutlineMoreVert } from "react-icons/md";
import QuestionItemRead from "../../components/aiControl/QuestionItemRead";
import { handleActiveSelect } from "../../features/layout/layoutSlice";
 
const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    color: ${({theme}) => theme.mainTextColor};
    
    .content{
      margin: 0 30px;
      margin-top: 40px;
      display: flex;

      .menu-side{
        width: 300px;
        height: auto;
        display: flex;
        flex-direction: column;
        gap: 20px;

        .menu-list{
          width: 300px;
          display: flex;
          flex-direction: column;
          border-radius: 10px;
          border: 1px solid ${({theme}) => theme.mainBorderColor};

          .menu-item{
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;

            .menu-item-top{
              width: 100%;
              height: 35px;
              display: flex;
              justify-content: space-between !important;
              align-items: center;
              padding: 0 5px 0 15px;
              position: relative;

              
              .menu-name{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
              }
              
              .more-icon{
                font-size: 1.4rem;
                fill: ${({theme}) => theme.mainTextColor};
                display: none;
              }
              
              &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
                
                .more-icon{
                  display: inline;
                }
              }
            }

            .sub-menu-list{
              display: flex;
              flex-direction: column;
              width: 100%;

              .sub-menu-item-title{
                width: 100%;
                height: 35px;
                display: flex;
                gap: 10px;
                align-items: center;
                padding: 0 5px 0 25px;
                position: relative;

                font-size: var(--font-size-sm);

                .subTitle-name{
                  font-size: 12px;
                  font-weight: var(--font-weight-lg);
                }

                .more-icon{
                  margin-left: auto;
                  display: none;
                  font-size: 1.4rem;
                  fill: ${({theme}) => theme.mainTextColor};
                }

                &:hover{
                  background-color: ${({theme}) => theme.secondaryBgColor};

                  .more-icon{
                    margin-left: auto;
                    display: inline;
                  }
                }
              }
            }

            .more-container{
              width: 140px;
              height: auto;
              background-color: ${({theme}) => theme.mainBgColor};
              position: absolute;
              top: 0;
              right: -145px;
              border-radius: 10px;
              display: flex;
              flex-direction: column;
              border: 1px solid ${({theme}) => theme.mainBorderColor};
              overflow: hidden;
              z-index: 20;

              .more-item{
                padding: 7px 10px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);

                &:hover{
                  background-color: ${({theme}) => theme.secondaryBgColor};
                }

              }

            }
          }
        }
      }

      .content-side{
        width: calc(100% - 340px);
        margin-left: 40px;
        height: auto;

        .content-top{
          width: 100%;
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 10px;


          h3{
            font-size: 20px;
            font-weight: var(--font-weight-lg);
          }

        }

        .sub-menu-list{
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 40px;
          padding-bottom: 60px;

          .sub-menu-item{
            width: 100%;

            .sub-menu-item-top{
              width: 100%;
              border-bottom: 2px solid ${({theme}) => theme.mainBorderColor};
              padding-bottom: 4px;
              margin-bottom: 10px;
              display: flex;
              justify-content: space-between;
              align-items: flex-end;

              .sub-menu-name{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
              }
            }

            .sub-menu-item-content{
              width: 100%;
              height: auto;

              .sub-menu-item-list{
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 10px;
              }
            }
          }
        }
      }
    }
  }
`;

const YapayZekaControl = () => {

    const {allQuestions, allTitles} = useSelector(state => state.aiControl)
    const {theme} = useSelector(state => state.layout)

    const dispatch = useDispatch()

    const [activeParentTitle, setActiveParentTitle] = useState(null)

    const [showedList, setShowedList] = useState([])

    const {activeSelect} = useSelector(state => state.layout)

    useEffect(() => {
        dispatch(getAllQuestions()) 
    },[])

    useEffect(() => {
      if(allQuestions?.length > 0){
        setShowedList(allQuestions[0].subTitles)
        setActiveParentTitle({id: allQuestions[0].id, titleName:allQuestions[0].titleName})
      }
    },[allQuestions])

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Yapay Zeka Ayarları"} position="sticky" />
        <div className="content">
          <div className="menu-side">
            <div className="menu-list">
              {
                allQuestions.map((item, i) => (
                  <div className="menu-item" key={item.titleId} onClick={() => { setActiveParentTitle({id: item.id, titleName: item.titleName}); setShowedList(item.subTitles)}}>
                    <div className="menu-item-top">
                      <div className="menu-name">{item.titleName}</div>
                      <MdOutlineMoreVert className="more-icon" title="Detaylar" onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect((activeSelect && activeSelect === `AIQuestionTitleMore${item.id}`) ? null : `AIQuestionTitleMore${item.id}`))}}/>
                    {
                      activeSelect === `AIQuestionTitleMore${item.id}` &&
                      <div className="more-container" onClick={(e)=> e.stopPropagation()}>
                        <div className="more-item" onClick={() => {dispatch(handleActiveSelect(null)); dispatch(showModal("aiChatTitleDetails")); dispatch(getaAiChatTitleDetails(item))}}>Detaylar</div>
                        <div className="more-item" onClick={() => {dispatch(handleActiveSelect(null)); dispatch(showModal("updateAiChatTitle")); dispatch(getAiTitleData(item))}}>Güncelle</div>
                        <div className="more-item" onClick={() => {dispatch(handleActiveSelect(null)); dispatch(showModal("updateAiChatTitleActivity")); dispatch(getAiTitleData(item))}}>Aktiflik Ayarla</div>
                        <div className="more-item" onClick={() => {dispatch(handleActiveSelect(null)); dispatch(showModal("addAiChatSubTitle")); dispatch(getAiQuestionGroupData(item))}}>Alt Başlık Ekle</div>
                        {/* <div className="more-item" onClick={() => {dispatch(handleActiveSelect(null)); dispatch(showModal("updateAiChatTitle")); dispatch(getAiTitleData({name: item.titleName, id: item.id}))}}>Güncelle</div> */}
                        <div className="more-item" onClick={() => {dispatch(handleActiveSelect(null)); dispatch(showModal("deleteAiChatTitlePermission")); dispatch(getAiTitleData({name: item.titleName, id: item.id, isTitle: true}))}}>Sil</div>
                      </div>
                    }
                    </div>
                      {
                        (item?.id === activeParentTitle?.id && item?.subTitles?.length > 0) &&
                        <div className="sub-menu-list" onClick={(e) => e.stopPropagation()}>
                          {
                            item.subTitles.map(innerItem => (
                              <div onClick={(e) => {e.stopPropagation(); setShowedList([innerItem])}} className="sub-menu-item-title">
                                <svg width="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 0.5C1.27614 0.5 1.5 0.723858 1.5 1V7C1.5 8.933 3.067 10.5 5 10.5H9V8.11325L14 11L9 13.8868V11.5H5C2.51472 11.5 0.5 9.48528 0.5 7V1C0.5 0.723858 0.723858 0.5 1 0.5Z" fill={theme === "light" ? "#000" : "#fff"}/>
                                </svg>
                                <span className="subTitle-name">{innerItem.subTitleName}</span>
                                <MdOutlineMoreVert className="more-icon" title="Detaylar" onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect((activeSelect && activeSelect === `AIQuestionSubTitleMore${innerItem.id}`) ? null : `AIQuestionSubTitleMore${innerItem.id}`))}}/>
                                {
                                  activeSelect === `AIQuestionSubTitleMore${innerItem.id}` &&
                                  <div className="more-container" onClick={(e)=> e.stopPropagation()}>
                                    {/* <div className="more-item" onClick={() => {}}>Detaylar</div> */}
                                    <div className="more-item" onClick={() => {dispatch(handleActiveSelect(null)); dispatch(getAiSubTitleData(innerItem)); dispatch(showModal("updateAISubTitle"))}}>Güncelle</div>
                                    <div className="more-item" onClick={() => {dispatch(handleActiveSelect(null)); dispatch(getAiSubTitleData(innerItem)); dispatch(showModal("updateAiChatSubTitleActivity"))}}>Aktiflik Ayarla</div>
                                    <div className="more-item" onClick={() => {dispatch(handleActiveSelect(null)); dispatch(getAiQuestionGroupData(innerItem)); dispatch(showModal("addAIQuestion"))}}>Soru Ekle</div>
                                    <div className="more-item" onClick={() => {dispatch(handleActiveSelect(null)); dispatch(showModal("updateAIQuestions")); dispatch(getUpdateQuestionsData(innerItem))}}>Soru Güncelle</div>
                                    <div className="more-item" onClick={() => {dispatch(handleActiveSelect(null)); dispatch(showModal("deleteAiChatTitlePermission")); dispatch(getAiTitleData({name: innerItem.subTitleName, id: innerItem.id, isTitle: false}))}}>Sil</div>
                                  </div>
                                }
                               </div>
                            ))
                          }
                        </div>
                      }
                  </div>
                ))
              }
            </div>
            <Btn bgColor="transparent" color="#E85446" borderColor="#E85446" width={"300px"}  handleClick={() => dispatch(showModal("addAiChatTitle"))}>Yeni Başlık Ekle</Btn>
            <Btn bgColor="transparent" color="#E85446" borderColor="#E85446" width={"300px"}  handleClick={() => dispatch(showModal("updateAiOrder"))}>Sırala</Btn>
          </div>
          <div className="content-side">
              <div className="content-top">
                <h3>{activeParentTitle?.titleName}</h3>
              </div>
              <div className="sub-menu-list">
                {
                  (showedList && showedList?.length > 0) ?
                  showedList?.map((item) => (
                    <div className="sub-menu-item" key={item.id}>
                      <div className="sub-menu-item-top">
                        <h4 className="sub-menu-name">{item.subTitleName}</h4>
                        {/* <Btn bgColor="transparent" color="#E85446" borderColor="#E85446" width={"120px"} height="30px" fontWeight={"700"} handleClick={()=> {dispatch(getAiQuestionGroupData(item)); dispatch(showModal("addAIQuestion"))}}>Soru Ekle</Btn> */}
                        {/* <Btn bgColor="transparent" color="#E85446" borderColor="#E85446" width={"120px"} height="30px" fontWeight={"700"} handleClick={()=> {dispatch(deleteAIChatSubTitle(item.id)) }}>Sil</Btn> */}
                      </div>
                      <div className="sub-menu-item-content">
                        <div className="sub-menu-item-list">
                          {
                            item?.messages.map((messageItem) => (
                              <QuestionItemRead messageItem={messageItem}/>
                            ))
                          }
                        </div>    
                      </div>
                    </div>
                  )):
                  <div>boş</div>
                }

              </div>
          </div>

        </div> 
      </div>
    </Container>
  )
}

export default YapayZekaControl